
export function loginChallenge (state: Record<string, any>, challenge: string) {
  state.loginChallenge = challenge
}

export function consentChallenge (state: Record<string, any>, challenge: string) {
  state.consentChallenge = challenge
}
